import React, { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { DeviceIcon } from '../DeviceIcon/DeviceIcon';
import { IDeviceDetailsProps, useDeviceDetailsPresenter } from './DeviceDetails.presenter';
import styles from './DeviceDetails.styles.m.css';
import { DeviceDetailsLine } from './DeviceDetailsLine/DeviceDetailsLine';
import { DeviceSessionIPLine } from './DeviceSessionIPLine/DeviceSessionIPLine';

export const DeviceDetails: FC<IDeviceDetailsProps> = (props) => {
  const { className, device, deviceSession, projectName, onCopiedToClipboard } = props;

  const { t } = useTranslation();
  const presenter = useDeviceDetailsPresenter({ device, projectName, deviceSession });

  return (
    <div className={className}>
      <div className={styles.header}>
        <div className={styles.deviceIconContainer}>
          <DeviceIcon
            platform={device.platform}
            status={device.status}
            className={styles.headerIcon}
          />
          {props.badgeIcon && (
            <IconView
              className={styles.badgeIcon}
              Icon={props.badgeIcon}
              size={IconViewSizes.Small}
            />
          )}
        </div>
        <div className={styles.deviceName}>{presenter.deviceName}</div>
        <div className={styles.lastActivity}>{presenter.lastActivity}</div>
      </div>
      <div className={styles.body}>
        <DeviceDetailsLine label={t('common_app')}>{presenter.appName}</DeviceDetailsLine>
        {deviceSession.location && (
          <DeviceDetailsLine label={t('common_location')}>
            {deviceSession.location}
          </DeviceDetailsLine>
        )}
        {presenter.deviceOS && (
          <DeviceDetailsLine label={t('common_os_version')}>{presenter.deviceOS}</DeviceDetailsLine>
        )}
        {deviceSession.ipAddress && (
          <DeviceSessionIPLine
            onCopiedToClipboard={onCopiedToClipboard}
            ipAddress={deviceSession.ipAddress}
          />
        )}
      </div>
    </div>
  );
};
